import { useEffect, useState } from 'react';
import { DEFAULT_LIVE_RANGE_HOURS } from './statisticsOverlayConstants';
import { hoursAgoInput, nowInput } from './statisticsOverlayHelpers';

export default function useStatisticsTimeControls({ statisticsFrom, statisticsTo, setRangeMode, setStatisticsFrom, setStatisticsTo }) {
  const [draftFrom, setDraftFrom] = useState(statisticsFrom || hoursAgoInput(DEFAULT_LIVE_RANGE_HOURS));
  const [draftTo, setDraftTo] = useState(statisticsTo || nowInput());

  useEffect(() => {
    setDraftFrom(statisticsFrom || hoursAgoInput(DEFAULT_LIVE_RANGE_HOURS));
  }, [statisticsFrom]);

  useEffect(() => {
    setDraftTo(statisticsTo || nowInput());
  }, [statisticsTo]);

  const applyRange = (fromValue, toValue) => {
    setStatisticsFrom(fromValue);
    setStatisticsTo(toValue);
    setRangeMode('range');
  };

  const applyPreset = (hours) => {
    const fromValue = hoursAgoInput(hours);
    const toValue = nowInput();
    setDraftFrom(fromValue);
    setDraftTo(toValue);
    applyRange(fromValue, toValue);
  };

  const handleFromChange = (event) => {
    const fromValue = event.target.value;
    setDraftFrom(fromValue);
    applyRange(fromValue, draftTo);
  };

  const handleToChange = (event) => {
    const toValue = event.target.value;
    setDraftTo(toValue);
    applyRange(draftFrom, toValue);
  };

  const handleLive = () => {
    const fromValue = hoursAgoInput(DEFAULT_LIVE_RANGE_HOURS);
    const toValue = nowInput();
    setDraftFrom(fromValue);
    setDraftTo(toValue);
    setStatisticsFrom(fromValue);
    setStatisticsTo(toValue);
    setRangeMode('live');
  };

  return {
    draftFrom,
    draftTo,
    applyPreset,
    handleFromChange,
    handleToChange,
    handleLive
  };
}
